import * as types from '../const/action.types';

export function client(state = {}, action) {
    switch (action.type) {
        case types.LOAD_CLIENT_SUCCESS:
            console.log(action.data);
            return action.data;
        default:
            return state;
    }
}

export function clients(state = [], action) {
    switch (action.type) {
        case types.LOAD_CLIENTS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function clientsHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.CLIENT_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function clientsIsLoading(state = false, action) {
    switch (action.type) {
        case types.CLIENTS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/client.reducer.js